import { EnvVariable, getEnv } from 'lib/helpers/envHelper';
import _ from 'lodash';
import { useRouter } from 'next/router';
import {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react';

interface IHistoryContext {
  previousAppRoute: string | undefined;
}

export const HistoryContext = createContext<IHistoryContext>({
  previousAppRoute: undefined,
});

export const useHistoryContext = () => useContext(HistoryContext);

interface IHistoryContextProviderProps {
  children: ReactNode;
}

export const HistoryContextProvider = ({
  children,
}: IHistoryContextProviderProps) => {
  const router = useRouter();
  const currentAsPathRef = useRef(router.asPath);
  const [previousAppRoute, setPreviousAppRoute] = useState<string>();

  const handleRouteChangeStart = (url: string) => {
    // Ignore external links
    if (!_.startsWith(url, '/')) {
      return;
    }
    // Ignore API calls
    if (_.startsWith(url, getEnv(EnvVariable.API_PATHNAME))) {
      return;
    }
    const { pathname: nextPathname } = new URL(url, window.location.origin);
    const { pathname: currentPathname } = new URL(
      currentAsPathRef.current,
      window.location.origin
    );
    if (nextPathname !== currentPathname) {
      setPreviousAppRoute(currentAsPathRef.current);
    }
    currentAsPathRef.current = url;
  };

  useEffect(() => {
    router.events.on('routeChangeStart', handleRouteChangeStart);
    return () => router.events.off('routeChangeStart', handleRouteChangeStart);
  }, []);

  return (
    <HistoryContext.Provider value={{ previousAppRoute }}>
      {children}
    </HistoryContext.Provider>
  );
};
